module.exports = __webpack_public_path__ + "static/img/1-5.ab30f710.png";